// React
import React from 'react';
import { useSelector } from 'react-redux';
// Styles
import './credits.css';
// Trads
import { trads as allTrads } from '../../datas/trads';
// Icons
import close from '../../style/assets/close.png';
import logo1 from '../../style/assets/logos/walraversyde-logo.png';
import logo2 from '../../style/assets/logos/atlantikwall-raversyde-logo.png';
import logo3 from '../../style/assets/logos/West-Vlaanderen.png';
import logo4 from '../../style/assets/logos/ToerismeVlaanderenENsubsidie-geel2.png';
import logo5 from '../../style/assets/logos/Interregvlaned_project_cmyk_pos.png';
import logo6 from '../../style/assets/logos/eu-flag.jpg';


export const Credits = (props: any) => {
	const language: string = useSelector((state: any) => state.user.language);

	const goBack = () => {
		props.displayCredits(false);
	};

	// @ts-ignore
	let trads = allTrads[language];

	return (
		<React.Fragment>
			<div
				className='clickable'
				style={{
					position: 'absolute',
					top: '20px',
					right: '20px',
					width: '50px',
					height: '50px',
					zIndex: 20000,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',

					borderRadius: '50%',
					backgroundColor: 'rgba(0, 0, 0, 0.2)',
					backgroundImage: `url(${close})`,
					backgroundSize: '25px 25px',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center',
				}}
				onClick={() => {
					goBack();
				}}
			></div>
			<div
				className='credits'
				id='credits'
				style={{
					zIndex: 15000,
					position: 'absolute',
					top: 0,
				}}
			>
				<h1 style={{
					marginBottom: '0%'
				}}>Credits</h1>
				<p
					style={{
						margin: '10%',
						width: '80%',
					}}
				>
					{trads.credits.content}
				</p>
				<div className='credits-logo'>
					<img className='credits-logoImg' src={logo1} alt='Walraversyde' />
					<img className='credits-logoImg' src={logo2} alt='Atlantikwall Raversyde' />
					<img className='credits-logoImg' src={logo3} alt='West-Vlaanderen' />
				</div>
				<div className='credits-logo'>
					<img className='credits-logoImg' src={logo4} alt='Toerisme Vlaanderen' />
					<img className='credits-logoImg' src={logo5} alt='Interreg' />
					<img className='credits-logoImg' src={logo6} alt='European Union' />
				</div>
			</div>
		</React.Fragment>
	);
};
